export default "__VITE_ASSET__Bn9e3fVn__"